//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

import moment from 'moment-timezone';

import { getDatesInRange } from '@utils/getDatesInRange';
import { normalizeToMap } from '@utils/normalize';

interface IEngagementStatByDay {
  date: Date | string;
}

const getFormattedDay = (d: Date | string) => moment(d).format('YYYY-MM-DD');

/**
 * Fills in missing day objects from the start date up to (but not including) the end date, using an
 * array of existing data. Favors the start/end date over the date array in offchance that these differ.
 */
export function fillInMissingDates<T extends IEngagementStatByDay>(
  days: T[],
  start: Date,
  end: Date,
  noDataValueFn: (date: Date) => T,
): T[] {
  const { byId: existingDaysMap } = normalizeToMap(days, (day) => getFormattedDay(day.date));

  return getDatesInRange(start, end, { inclusive: false }).map((date) => {
    const dateKey = getFormattedDay(date);
    const existingDay = existingDaysMap.get(dateKey);
    return existingDay ?? noDataValueFn(date);
  });
}
